import { always, tryCatch } from 'ramda'
import { querySearch } from '@app-components/search/search.factory'

tryCatch(querySearch, always(null))('.error-page--search .global-search-container')
